// src/components/layout/Footer.js
import React, { useContext } from 'react';
import { AppThemeContext } from '../../context/AppThemeContext'; // Adjust path if necessary
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  const { theme } = useContext(AppThemeContext);

  return (
    <footer
      className="app-footer" // You can add more specific styles in App.css or a Footer.css
      style={{
        padding: '3px 20px',
        textAlign: 'center',
        borderTop: `1px solid ${theme === 'dark' ? '#383838' : '#dee2e6'}`,
        fontSize: '0.85rem',
        color: theme === 'dark' ? '#888888' : '#6c757d',
        marginTop: 'auto', // Pushes footer to bottom if content is short
        backgroundColor: theme === 'dark' ? '#212124' : '#f8f9fa',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap' // Allow wrapping on small screens
      }}
    >
      <div style={{ flex: 1, textAlign: 'left', minWidth: '150px', marginBottom: '1px' }}>
        Special thanks to  <a href="https://github.com/xxmichaellong/ptcg-sim" target="_blank" rel="noopener noreferrer" style={{color: theme === 'dark' ? '#dda0dd' : '#0d6efd'}}>xxmichaellong</a> and <a href="https://github.com/xxmichaellong/ptcg-sim" target="_blank" rel="noopener noreferrer" style={{color: theme === 'dark' ? '#dda0dd' : '#0d6efd'}}><a href="https://github.com/Tishinator/PTCGDeckBuilder" target="_blank" rel="noopener noreferrer" style={{color: theme === 'dark' ? '#dda0dd' : '#0d6efd'}}>tishinator</a></a>.
      </div>
      <div style={{ flex: 1, textAlign: 'center', minWidth: '150px', marginBottom: '1px' }}>
        &copy; 2025 @EnvoyOfHell
      </div>
      <div style={{ flex: 1, textAlign: 'center', minWidth: '150px', marginBottom: '1px', paddingRight: '0px' }}>
        <a href="https://github.com/EnvoysRealm/Meta-Ptcg-DeckBuilder" target="_blank" rel="noopener noreferrer" style={{color: theme === 'dark' ? '#dda0dd' : '#0d6efd', textDecoration: 'none'}}>
          <FontAwesomeIcon icon={faGithub} /> GitHub
        </a>
      </div>
    </footer>
  );
}

export default Footer;
